import React from "react";

const Footer = (props) => (
  <footer>{props.text}</footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/EricLightbox/components/Footer.js